import { getAtomValue } from '../data/atomUtils';
import { autocompleteCommandIsActiveAtom, charsOffFromResultAtom, resetCharsOffFromResultAtom, updateAutocompleteActiveRange, updateCharsOffFromResultBasedOnKeyPressed, updateActiveAutocompleteTrigger
// @ts-expect-error Untyped module
} from '../data/autocompleteAtoms';
import { AUTOCOMPLETE_MODES, findActiveTriggerRange, gatherFilteredCommands, getAutocompleteCommandTriggers, getTextForRangeWithoutTrigger, openAutocompleteInlineDropdownMenu, removeSpanAndResetState
// @ts-expect-error Untyped module
} from './utils';
export default async function handleAutocompleteCommandChange(editor, keyPressed) {
  const triggerMap = editor.autoCompleteCommands;
  if (!triggerMap) {
    return;
  }
  const triggers = getAutocompleteCommandTriggers(editor);
  const {
    activeTrigger,
    activeAutocompleteRange
  } = findActiveTriggerRange(editor, triggers, AUTOCOMPLETE_MODES.COMMAND);
  if (!activeTrigger || !activeAutocompleteRange) {
    console.warn('No trigger or range found for complete command, something went wrong');
    removeSpanAndResetState(editor);
    return;
  }
  const autocompleteCommandIsActive = getAtomValue(autocompleteCommandIsActiveAtom);
  if (autocompleteCommandIsActive) {
    updateAutocompleteActiveRange(activeAutocompleteRange);
  }
  const filtersForActiveTrigger = triggerMap[activeTrigger];
  const rangeText = getTextForRangeWithoutTrigger(activeAutocompleteRange, true);
  const filteredCommands = await gatherFilteredCommands(filtersForActiveTrigger, rangeText);
  if (filteredCommands.length === 0) {
    updateCharsOffFromResultBasedOnKeyPressed(keyPressed);
    const charsOffFromResult = getAtomValue(charsOffFromResultAtom);
    if (charsOffFromResult >= 3) {
      removeSpanAndResetState(editor);
    }
  } else {
    resetCharsOffFromResultAtom();
  }
  updateActiveAutocompleteTrigger(activeTrigger);
  openAutocompleteInlineDropdownMenu(editor, filteredCommands, activeAutocompleteRange);
}